import type { ShouldRevalidateFunction } from "react-router"
import Root from "./root.component"

export { clientLoader } from "./root.client-loader"
export { clientMiddleware } from "./root.client-middleware"
export { ErrorBoundary } from "./root.error-boundary"
export { Layout } from "./root.layout"
export { links } from "./root.links"
export { meta } from "./root.meta"
export default Root

// By default, React Router skips revalidating a route's loader when the route's
// own pathname and params haven't changed. The root route's pathname is always "/"
// with no params, so without this override the root loader would almost never re-run
// on child navigations. The root middleware still runs on every navigation — but the
// loader that bridges middleware context into loaderData (and thus into the React
// component tree) does not, leaving the app time snapshot stale until the next
// periodic revalidation. Since the root loader is trivial (reads one context value),
// forcing revalidation on every navigation is cheap and keeps time consistent.
export const shouldRevalidate: ShouldRevalidateFunction = () => true
